import { Phone } from "lucide-react";

const PHONE_NUMBER = "+919310745117";

export default function FloatingCallButton() {
    return (
        <a
            href={`tel:${PHONE_NUMBER}`}
            className="fixed bottom-6 left-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-blue-500 hover:bg-blue-600 shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 hover:scale-110 group"
            title="Call us"
            data-testid="floating-call-button"
        >
            <Phone size={20} className="text-white group-hover:scale-125 transition-transform duration-300" />
        </a>
    );
}
